/**
 * Handler for display of flash messages client-side
 */
class FlashMessages {
    constructor() {
        this.errorTemplate = (data) => (`<div class="alert alert-danger" role="alert"><div class="container"><strong>${data.title}</strong>${data.message}</div></div>`);
        this.warningTemplate = (data) => (`<div class="alert alert-warning" role="alert"><div class="container"><strong>${data.title}</strong>${data.message}</div></div>`);
        this.messages = [];
        this.$window = $(window);
    }

    /**
     * Display flash error message
     * @param {String} title
     * @param {String} message
     * @param {object} $container [optional]
     */
    addError(title, message, $container) {
        this.addFlash(this.errorTemplate, title, message, $container);
    }

    /**
     * Display flash error message
     * @param {String} title
     * @param {String} message
     * @param {object} $container [optional]
     */
    addWarning(title, message, $container) {
        this.addFlash(this.warningTemplate, title, message, $container);
    }

    /**
     * @param {Function} template
     * @param {String} title [optional]
     * @param {String} message [optional]
     * @param {object} $container [optional]
     */
    addFlash(template, title = '', message = '', $container = null) {
        title = title || '';
        message = message || '';

        if (!$container) {
            $container = $('<div class="messages"/>');
            $('.header').after($container);
        }

        //Create, and cache reference to error
        const $alert = $(template({ title: title, message: message }));
        this.messages.push($alert);

        $container.prepend($alert);

        this.$window.scrollTop($container.offset().top);
    }

    /**
     * Clear and flash messages present
     * @return {FlashMessages}
     */
    clear() {
        for (var i in this.messages) {
            if (this.messages.hasOwnProperty(i)) {
                this.messages[i].remove();
            }
        }

        return this;
    }
}

export default FlashMessages;
